import React from 'react'

import AdminMarket from '../admin/AdminMarket'

const MarketInformationsView = () => <AdminMarket />

export default MarketInformationsView
